import { OrderIndData, OrderIntValidationState } from "../types";
import { createUseValidator } from "../../../../core/util/hooks";

export const orderIndValidationState: OrderIntValidationState = {
  productId: true,
};

export const useOrderIndValidator = createUseValidator<OrderIndData, OrderIntValidationState>(
  orderIndValidationState
);
